const pixelId = process.env.REACT_APP_META_PIXEL_ID?.trim();
let initialized = false;
let lastPageView = null;

export function initMetaPixel() {
  if (!pixelId || initialized) return Boolean(pixelId);

  if (!window.fbq) {
    const fbq = function (...args) {
      if (fbq.callMethod) fbq.callMethod.apply(fbq, args);
      else fbq.queue.push(args);
    };
    fbq.push = fbq;
    fbq.loaded = true;
    fbq.version = "2.0";
    fbq.queue = [];
    window.fbq = fbq;

    const script = document.createElement("script");
    script.id = "meta-pixel-script";
    script.async = true;
    script.src = "https://connect.facebook.net/en_US/fbevents.js";
    document.head.appendChild(script);
  }

  window.fbq("init", pixelId);
  initialized = true;
  return true;
}

export function track(eventName, parameters = {}) {
  if (!initMetaPixel()) return;
  window.fbq("track", eventName, parameters);
}

export function trackCustom(eventName, parameters = {}) {
  if (!initMetaPixel()) return;
  window.fbq("trackCustom", eventName, parameters);
}

export function trackPageView(routeKey) {
  if (!initMetaPixel() || lastPageView === routeKey) return;
  lastPageView = routeKey;
  window.fbq("track", "PageView");
}

export function trackPurchaseOnce(dedupeKey, parameters = {}) {
  if (!initMetaPixel()) return;
  if (sessionStorage.getItem(dedupeKey)) return;
  sessionStorage.setItem(dedupeKey, "1");
  window.fbq("track", "Purchase", parameters);
}
